import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { jwtDecode } from "jwt-decode";
import * as Sentry from "@sentry/react";

const AuthSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login, isLoggedIn } = useAuth();

  // Calculate provider name directly from URL, with a fallback.
  const providerParam = searchParams.get("provider") || "provider";
  const providerName = providerParam.charAt(0).toUpperCase() + providerParam.slice(1);
  
  useEffect(() => {
    const hpSessionToken = searchParams.get("session_token");
    const promoCode = searchParams.get("promo");
    let tokenToProcess = hpSessionToken;
    let authSource = "HP Promo";
    console.log("searchParams", searchParams);
    console.log("Search Token", searchParams.get("token"));

    if (!hpSessionToken) {
      tokenToProcess = searchParams.get("token");
      authSource = "Google";
    }

    if (tokenToProcess) {
      try {
        console.log("Token to Process", tokenToProcess);
        const decoded = jwtDecode(tokenToProcess);
        const user_id = decoded?.id || decoded?.user_id;

        if (decoded.exp * 1000 > Date.now()) {
          login(tokenToProcess, user_id);
          
          if (promoCode === 'HP1M' && authSource === 'HP Promo') {
            localStorage.setItem('hpPromoActivated', 'true');
            console.log('HP Promo activation successful. Welcome message flag set.');
          }

          // --- Office Dialog API integration ---
          if (window.Office && window.Office.context && window.Office.context.ui) {
            // Send token to parent and close dialog
            Office.context.ui.messageParent(JSON.stringify({ token: tokenToProcess, user_id, provider: providerName }));
          } else if (window.opener && window.opener !== window) {
            // This is a popup window - save token to localStorage for parent to pick up
            localStorage.setItem('oauth_token', tokenToProcess);
            localStorage.setItem('oauth_user_id', user_id);
            console.log(`✅ ${providerName} token saved to localStorage for PowerPoint popup`);
            // Close the popup
            window.close();
          } else {
            // Regular browser - redirect to home
            window.location.href = "/";
          }
          // --- End Office Dialog API integration ---

        } else {
          console.error(`${authSource} token expired.`);
          navigate("/");
        }
      } catch (err) {
        console.error(`Invalid token from ${authSource} redirect:`, err);
        navigate("/");
      }
    } else {
      console.error("No token found in query parameters for authentication.");
      navigate("/");
    }
  }, [searchParams, navigate, login]);
  
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="flex items-center space-x-2 animate-pulse">
        <svg
          className="w-8 h-8 text-blue-600 animate-spin"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
          ></path>
        </svg>

        <p className="text-lg text-gray-700 font-semibold">Authenticating…</p>
      </div>
      <p className="text-sm text-gray-500 mt-2">Please wait while we log you in securely</p>
    </div>
  );
};

export default AuthSuccess;